import { ChangeDetectionStrategy, Component } from '@angular/core'

import { IconUi } from './icon-ui'

@Component({
  selector: 'eye-icon',
  imports: [IconUi],
  template: `<icon-ui
    name="eye"
    class="size-5" />`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeIcon {}

@Component({
  selector: 'eye-off-icon',
  imports: [IconUi],
  template: `<icon-ui
    name="eye-off"
    class="size-5" />`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeOffIcon {}
